import { DialogContainerComponent } from './dialog-container.component';
export * from './dialog-container.component';

import { ConfirmationComponent } from './confirmation.component';
export * from './confirmation.component';

export const COMPONENTS = [
  DialogContainerComponent,
  ConfirmationComponent
];